import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { isMorningBriefing, isEveningBriefing } from './currentTimeCheckUtils';
/**
 * Checks if the inbox briefing SUA should be shown based on feature flight, user setting, and current time.
 * @returns true if inbox briefing should be displayed
 */
export function shouldShowInboxBriefingsSUA(): boolean {
    return (
        isGlobalFeatureEnabled('mon-copilot-inbox-briefings') &&
        (isMorningBriefing() || isEveningBriefing())
    );
}
